module.exports = __webpack_public_path__ + "static/media/heroGraphic1000.8f4e58bd.png";